// Angular Imports
import { NgModule } from '@angular/core';
// This Module's Components
import { CookieBannerComponent } from './cookie-banner.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [CookieBannerComponent],
  exports: [CookieBannerComponent]
})
export class CookieBannerModule {}
